<template>
  <v-dialog
    v-model="isOpenModalComparaison"
    :scrim="false"
    :fullscreen="$vuetify.breakpoint.mobile"
    :width="$vuetify.breakpoint.mobile ? '' : widthModaleGraphe"
    @click:outside="onClose"
  >
    <v-card class="left-vertical-card px-6">
      <div class="d-flex bg-titre">
        <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
          {{ titre }}
        </div>
        <v-btn
          class="align-self-center"
          text
          @click="onClose"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <BaseErrorMessage
        v-if="erreur.updateFiltres"
        message="Erreur serveur. merci de réessayer plus tard."
      />
      <v-row
        no-gutters
      >
        <v-col
          class="px-3 pb-6"
          cols="12"
          md="4"
          @click="onAnyClickFiltres"
        >
          <AgrialSelect
            v-model="regionAgrialSelected"
            :disabled="loading.updateFiltres"
            :class="regionAgrialSelected.length > 1 ? 'input-multiple' : 'pt-1'"
            :clearable="abonnements.culturialAbonne"
            :menu-props="{ top: true, offsetY: true }"
            :items="filtresValeursPossibles.regionsAgrial"
            :readonly="!abonnements.culturialAbonne"
            item-text="libelle"
            label="Régions Agrial"
            multiple
            hide-details
            return-object
            @change="updateFiltresAdherent"
          >
            <template
              v-if="!abonnements.culturialAbonne"
              v-slot:prepend-inner
            >
              <v-icon
                class="prepend-icon"
                color="var(--gris-clair)"
                size="18"
              >
                mdi-lock
              </v-icon>
            </template>
          </AgrialSelect>
          <div
            v-if="regionAgrialSelected == null || (regionAgrialSelected!= null && regionAgrialSelected.length<1)"
            class="pl-1 red--text"
          >
            Au moins une région doit être sélectionnée
          </div>
        </v-col>
        <v-col
          v-if="$vuetify.breakpoint.mobile && regionAgrialSelected.length>=3"
          cols="auto"
          class="mb-5 px-3"
        >
          <BaseMessageV2 message="Le chargement des comparaisons augmente avec le nombre de régions sélectionnées" />
        </v-col>
        <v-col
          class="px-3"
          cols="12"
          md="4"
          @click="onAnyClickFiltres"
        >
          <AgrialSelect
            v-model="potentielSolSelected"
            :disabled="loading.updateFiltres"
            :items="filtresValeursPossibles.potentielSol"
            :readonly="!abonnements.culturialAbonne"
            item-text="libelle"
            label="Potentiel de sol"
            class="pt-1"
            return-object
            @change="updateFiltresAdherent"
          >
            <template
              v-if="!abonnements.culturialAbonne"
              v-slot:prepend-inner
            >
              <v-icon
                class="prepend-icon"
                color="var(--gris-clair)"
                size="18"
              >
                mdi-lock
              </v-icon>
            </template>
          </AgrialSelect>
        </v-col>
        <v-col
          class="px-3"
          cols="12"
          md="4"
          @click="onAnyClickFiltres"
        >
          <AgrialSelect
            v-model="typeExploitationSelected"
            :disabled="loading.updateFiltres"
            :items="filtresValeursPossibles.typeExploitation"
            :readonly="!abonnements.culturialAbonne"
            item-text="libelle"
            label="Type d'exploitation"
            class="pt-1"
            return-object
            @change="updateFiltresAdherent"
          >
            <template
              v-if="!abonnements.culturialAbonne"
              v-slot:prepend-inner
            >
              <v-icon
                class="prepend-icon"
                color="var(--gris-clair)"
                size="18"
              >
                mdi-lock
              </v-icon>
            </template>
          </AgrialSelect>
        </v-col>
      </v-row>
      <v-row
        v-if="!$vuetify.breakpoint.mobile"
        no-gutters
      >
        <v-col
          v-if="regionAgrialSelected.length>=3"
          cols="auto"
          class="mb-5 px-3"
        >
          <BaseMessageV2 message="Le chargement des comparaisons augmente avec le nombre de régions sélectionnées" />
        </v-col>
      </v-row>
      <BaseLoader v-if="loading.graphe" />
      <v-row
        v-if="!loading.graphe"
        no-gutters
        class="justify-center px-2"
      >
        <v-col
          cols="12"
          class="pa-1"
          :md="mdModaleGraphe"
        >
          <PoidsTotalLivre
            :annee-recolte-selected="anneeRecolteActive"
            :code-graine-rs3-selected="codeGraineActive"
          />
        </v-col>
        <v-col
          v-if="comparaisonQualitePS && codesGraphesConstruisibles.includes('PS') && regionAgrialSelected!=null && regionAgrialSelected.length>0"
          cols="12"
          class="pa-1"
          :md="mdModaleGraphe"
        >
          <BaseCardV2
            class="pa-2"
            titre="PS : Répartition des moyennes des adhérents"
          >
            <BaseComparaisonLegende
              v-if="!loading.graphe"
              :donnee-perso="{libelle: 'Mon exploitation'}"
              class="mt-3 ml-3"
            />
            <BaseComparaisonBarChart
              id="ps"
              class="mt-12"
              :chart-data="chartDataPS"
            />
            <div>
              <div
                v-if="!loading.graphe && comparaisonQualitePS.nbAdherent > 1"
                class="my-4 texte-gris-fonce texte"
              >
                Comparaison avec {{ comparaisonQualitePS.nbAdherent }} adhérent{{ comparaisonQualitePS.nbAdherent > 1
                  ? 's' : '' }}
              </div>
              <div
                v-if="!loading.graphe && comparaisonQualitePS.nbAdherent === 1"
                class="my-4 texte-gris-fonce texte"
              >
                <BaseMessageV2 message="Nombre d'adhérents insuffisant pour la comparaison (&lt; 1 adhérent)" />
              </div>
            </div>
          </BaseCardV2>
        </v-col>
        <v-col
          v-if="comparaisonQualiteProteine && codesGraphesConstruisibles.includes('PROTEINE') && regionAgrialSelected!=null && regionAgrialSelected.length> 0"
          cols="12"
          class="pa-1"
          :md="mdModaleGraphe"
        >
          <BaseCardV2
            class="pa-2"
            titre="Protéine : Répartition des moyennes des adhérents"
          >
            <BaseComparaisonLegende
              v-if="!loading.graphe"
              :donnee-perso="{libelle: 'Mon exploitation'}"
              class="mt-3 ml-3"
            />
            <BaseComparaisonBarChart
              id="proteine"
              class="mt-8"
              :chart-data="chartDataProteine"
            />
            <div>
              <div
                v-if="!loading.graphe && comparaisonQualiteProteine.nbAdherent > 1"
                class="my-4 texte-gris-fonce texte"
              >
                Comparaison avec {{ comparaisonQualiteProteine.nbAdherent }} adhérent{{
                  comparaisonQualiteProteine.nbAdherent > 1 ? 's' : '' }}
              </div>
              <div
                v-if="!loading.graphe && comparaisonQualiteProteine.nbAdherent === 1"
                class="my-4 texte-gris-fonce texte"
              >
                Nombre d'adhérents insuffisant pour la comparaison (&lt; 1 adhérent)
              </div>
            </div>
          </BaseCardV2>
        </v-col>
        <v-col
          v-if="comparaisonQualiteHumidite && codesGraphesConstruisibles.includes('HUMIDITE') && regionAgrialSelected!=null && regionAgrialSelected.length> 0"
          cols="12"
          class="pa-1"
          :md="mdModaleGraphe"
        >
          <BaseCardV2
            class="pa-2"
            titre="Humidite : Répartition des moyennes des adhérents"
          >
            <BaseComparaisonLegende
              v-if="!loading.graphe"
              :donnee-perso="{libelle: 'Mon exploitation'}"
              class="mt-6 ml-3"
            />
            <BaseComparaisonBarChart
              id="humidite"
              class="mt-8"
              :chart-data="chartDataHumidite"             
            />
            <div>
              <div
                v-if="!loading.graphe && comparaisonQualiteHumidite.nbAdherent > 1"
                class="my-4 texte-gris-fonce texte"
              >
                Comparaison avec {{ comparaisonQualiteHumidite.nbAdherent }} adhérent{{
                  comparaisonQualiteHumidite.nbAdherent > 1 ? 's' : '' }}
              </div>
              <div
                v-if="!loading.graphe && comparaisonQualiteHumidite.nbAdherent === 1"
                class="my-4 texte-gris-fonce texte"
              >
                <BaseMessageV2 message="Nombre d'adhérents insuffisant pour la comparaison (&lt; 1 adhérent)" />
              </div>
            </div>
          </BaseCardV2>
        </v-col>
      </v-row>

      <v-card
        v-if="!loading.graphe && !hasDonnees"
        class="d-flex align-center flex-column pb-6"
      >
        <img
          alt="no-comparaison"
          class="mt-5"
          src="@/assets/no-comparaison.svg"
        >
        <div
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          class=" d-flex flex-column intro texte-gris-fonce  mt-2 text-justify mx-5"
        >
          <span class="text-center">Pas de comparaison disponible pour cette graine et cette récolte.</span>
        </div>
      </v-card>
      <div class="d-flex justify-center py-3 mt-3">
        <AgrButton
          class="pa-5 branche"
          @click="onPageOutilsAnalyse()"
        >
          Voir ma synthèse
        </AgrButton>
      </div>
      <div
        class="d-flex justify-center asterix mt-3 pb-16 pb-md-3"
      >
        * Evolution par rapport à l’année précédente
      </div>
      <InformationAbonnementModal
        v-if="isOpenModalInformationAbonnement"
        :is-open-modal-information-abonnement="isOpenModalInformationAbonnement"
        code-feature="FILTRE_COMPARAISON"
        texte="Affinez vos comparaisons en choisissant le type d'exploitation avec lequel vous souhaitez vous comparer."
        titre="Filtres de comparaison"
        @close="isOpenModalInformationAbonnement = false"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {round} from 'lodash'
import AgrialSelect from '@/components/form/agrial-select.vue'
import {AgrButton} from '@agrial/ui'
import BaseErrorMessage from '@/components/common/base-error-message.vue'
import BaseComparaisonBarChart from '@/components/chart/base-comparaison-bar-chart.vue'
import BaseComparaisonLegende from '@/components/chart/base-comparaison-legende.vue'
import PoidsTotalLivre from '../poids-total-livre.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import colorsService from '@/service/colors.service'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageV2 from '@/components/common/base-message-v2.vue'

export default {
  name: 'ComparaisonApportsModal',
  components: {BaseCardV2, BaseComparaisonBarChart, BaseComparaisonLegende, BaseErrorMessage, BaseLoader, BaseMessageV2, AgrButton , AgrialSelect, InformationAbonnementModal, PoidsTotalLivre},
  props: {
    titre: {
      type: String,
      default: null
    },
    isOpenModalComparaison: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      loading: {
        qualite: false,
        graphe: false,
        updateFiltres: false,
      },
      erreur: {
        qualite: false,
        graphe: false,
        updateFiltres: false,
      },
      comparaisonQualitePS: null,
      comparaisonQualiteProteine: null,
      comparaisonQualiteHumidite: null,
      qualiteSelected: {},
      panel: [0], // permet d'ouvrir le premier élement du collapsible par défaut
      regionAgrialSelected: null,
      typeExploitationSelected: null,
      typeProductionSelected: null,
      potentielSolSelected: null,
      ressourceEffluentSelected: null,
      stockeurSelected: null,
      isOpenModalInformationAbonnement: false,
    }
  },

  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      graphesConstruisibles: 'comparaisonQualite/listeGraphesConstruisibles',
      filtresValeursPossibles: 'filtresComparaison/filtresValeursPossibles',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive'
    }),
    hasDonnees () {
      return (this.comparaisonQualitePS != null && this.comparaisonQualitePS.moyenneAdherent)
        || (this.comparaisonQualiteProteine != null && this.comparaisonQualiteProteine.moyenneAdherent)
        || (this.comparaisonQualiteHumidite != null && this.comparaisonQualiteHumidite.moyenneAdherent)
    },
    codesGraphesConstruisibles () {
      return this.graphesConstruisibles.map(c =>c.code)
    },
    chartDataPS () {
      return this.getChartData(this.comparaisonQualitePS)
    },
    chartDataProteine () {
      return this.getChartData(this.comparaisonQualiteProteine)
    },
    chartDataHumidite () {
      return this.getChartData(this.comparaisonQualiteHumidite)
    },
    hasDeuxQualite () {
      return this.codesGraphesConstruisibles.length === 2
    },
    countNbGraphes () {
      return this.regionAgrialSelected!=null && this.regionAgrialSelected.length> 0 ? this.codesGraphesConstruisibles.length + 1 : 1
    },
    widthModaleGraphe () {
      let result = 0
      if (this.countNbGraphes === 1 || this.countNbGraphes === 2 || this.countNbGraphes === 4) {
        result = '50%'
      } else {
        result = '85%'
      }
      return result
    },
    mdModaleGraphe () {
      let result = 0
      if (this.countNbGraphes === 1) {
        result = 10
      } else if (this.countNbGraphes === 2 || this.countNbGraphes === 4) {
        result = 6
      } else {
        result = 4
      }
      return result
    },

  },

  created () {
    this.resetAllSelects()
    this.fetchAbonnements()
    this.loadGraphesConstruisibles()
  },

  methods: {
    ...mapActions({
      fetchAbonnements: 'adherent/fetchAbonnements',
      getGrapheConstruisibles: 'comparaisonQualite/getGrapheConstruisible',
      getComparaisonQualitePS: 'comparaisonQualite/getComparaisonQualitePS',
      getComparaisonQualiteProteine: 'comparaisonQualite/getComparaisonQualiteProteine',
      getComparaisonQualiteHumidite: 'comparaisonQualite/getComparaisonQualiteHumidite',
      incrementerAccesSouscriptionAbonnement: 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
      setFiltres: 'filtresComparaison/setFiltres',

    }),
    resetAllSelects () {
      this.typeExploitationSelected = this.filtresAdherent.typeExploitation
      this.typeProductionSelected = this.filtresAdherent.typeProduction
      this.potentielSolSelected = this.filtresAdherent.potentielSol
      this.ressourceEffluentSelected = this.filtresAdherent.ressourceEffluents
      this.stockeurSelected = this.filtresAdherent.stockeur
      this.regionAgrialSelected = this.filtresAdherent.regionsAgrial
    },
    updateFiltresAdherent () {
      this.loading.updateFiltres = true
      this.erreur.updateFiltres = false

      const filtresAUpdate = {
        typeExploitation: this.typeExploitationSelected,
        typeProduction: this.typeProductionSelected,
        potentielSol: this.potentielSolSelected,
        ressourceEffluents: this.ressourceEffluentSelected,
        stockeur: this.stockeurSelected,
        regionsAgrial: this.regionAgrialSelected
      }
      return this.setFiltres(filtresAUpdate)
        .then(() => {
          this.resetAllSelects()
          this.loadGraphesConstruisibles()
        })
        .catch(() => this.erreur.updateFiltres = true)
        .finally(() => this.loading.updateFiltres = false)
    },
    getChartData (data) {
      if (data === null || (!data.paliers)) {
        return {}
      }
      let nbPaliers = data.paliers.length
      return {
        labels: data.paliers.map(c => this.formatPalier(c.borneMin, c.borneMax)),
        datasets: [{
          type: 'bar',
          indexAdherent: data.adherentIndexMoyenneCampagneEnCours,
          moyenneAdherent: round(data.moyenneAdherent, 1),
          borderRadius: 5,
          borderSkipped: false,
          barPercentage: 1.1,
          backgroundColor: this.backgroundColors(data.adherentIndexMoyenneCampagneEnCours, nbPaliers),
          data: data.paliers.map(c => round(c.pourcentageExploitationCampagneEnCours, 0))
        }]
      }
    },
    loadGraphesConstruisibles () {
      this.loading.qualite = true
      this.erreur.qualite = false
      this.getGrapheConstruisibles(this.codeGraineActive)
        .then(() => {
          if (this.graphesConstruisibles.length) {
            this.qualiteSelected = this.graphesConstruisibles[0]
            if (this.codesGraphesConstruisibles.includes('HUMIDITE')) {
              this.loadGrapheComparaisonQualiteHumidite()
            }
            if (this.codesGraphesConstruisibles.includes('PS')) {
              this.loadGrapheComparaisonQualitePS()
            }
            if (this.codesGraphesConstruisibles.includes('PROTEINE')) {
              this.loadGrapheComparaisonQualiteProteine()
            }
          }
        })
        .catch(() => {
          this.erreur.qualite = true
        })
        .finally(() => {
          this.loading.qualite = false
        })
    },
    loadGrapheComparaisonQualitePS () {
      this.loading.graphe = true
      this.erreur.graphe = false

      let params = {
        anneeCourante: this.anneeRecolteActive,
        codeGraineRs3: this.codeGraineActive,
        filtres: this.filtresAdherent
      }
      this.getComparaisonQualitePS(params)
        .then((result) => {
          this.comparaisonQualitePS = result
        })
        .catch(() => {
          this.erreur.graphe = true
        })
        .finally(() => {
          this.loading.graphe = false
        })
    },
    loadGrapheComparaisonQualiteProteine () {
      this.loading.graphe = true
      this.erreur.graphe = false

      let params = {
        anneeCourante: this.anneeRecolteActive,
        codeGraineRs3: this.codeGraineActive,
        filtres: this.filtresAdherent
      }
      this.getComparaisonQualiteProteine(params)
        .then((result) => {
          this.comparaisonQualiteProteine = result
        })
        .catch(() => {
          this.erreur.graphe = true
        })
        .finally(() => {
          this.loading.graphe = false
        })
    },
    loadGrapheComparaisonQualiteHumidite () {
      this.loading.graphe = true
      this.erreur.graphe = false

      let params = {
        anneeCourante: this.anneeRecolteActive,
        codeGraineRs3: this.codeGraineActive,
        filtres: this.filtresAdherent
      }
      this.getComparaisonQualiteHumidite(params)
        .then((result) => {
          this.comparaisonQualiteHumidite = result
        })
        .catch(() => {
          this.erreur.graphe = true
        })
        .finally(() => {
          this.loading.graphe = false
        })
    },
    formatPalier (borneMin, borneMax) {
      let result
      if (borneMin == null) {
        result = '< ' + borneMax
      } else if (borneMax == null) {
        result = '> ' + borneMin
      } else {
        result = borneMin + ' - ' + borneMax
      }
      return result
    },
    backgroundColors (index, nbPaliers) {
      let colorMoyenne = colorsService.barChart.grapheCompositionQualite.grey
      let colorPerso = colorsService.barChart.grapheCompositionQualite.perso
      const results = []
      for (let i = 0; i < nbPaliers; i++) {
        results.push(i === index ? colorPerso : colorMoyenne)
      }
      return results
    },
    onPageOutilsAnalyse () {
      this.$router.push({ name: 'main.mes-outils-d-analyse' })
    },
    onAnyClickFiltres () {
      if (!this.abonnements.culturialAbonne) {
        this.isOpenModalInformationAbonnement = !this.isOpenModalInformationAbonnement
        this.incrementerAccesSouscriptionAbonnement('FILTRE_COMPARAISON')
      }
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
  background-color: #f1f2f5;
}
.bg-titre {
  height: 70px;
}
.prepend-icon {
  z-index: 100;
}
.asterix {
  font-size: 0.875rem;
  color: var(--gris-fonce);
}
.input-multiple {
  height: 60px !important;
  overflow-y: scroll;
  padding-top: 5px;
}
</style>
